import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { useLocalizationContext } from '../../hooks/LocalizationContext';

export interface HourlyRateProps {
    hourlyRateInUsdCents: number;
    fontSize?: React.ComponentProps<typeof Text>['size'];
    fontColor?: React.ComponentProps<typeof Stack>['color'];
}

const TRANSLATION_KEY = 'seller_pages_toolbox.hourly_rate';

export const HourlyRate = ({ hourlyRateInUsdCents, fontSize = 'b_lg', fontColor = 'grey_1100' }: HourlyRateProps) => {
    const { currencyFormatFromUSD } = useLocalizationContext();

    if (!hourlyRateInUsdCents) return null;

    return (
        <Stack gap="0" color={fontColor}>
            <Text fontWeight="bold" size={fontSize} color="inherit">
                {currencyFormatFromUSD(hourlyRateInUsdCents / 100)}/
            </Text>
            <Text fontWeight="normal" size={fontSize} color="inherit">
                <I18n k={`${TRANSLATION_KEY}.hour`} />
            </Text>
        </Stack>
    );
};
